module.exports = {
  "media": {
    "mobile": "(min-width: 520px)",
    "tablet": "(min-width: 768px)",
    "desktop": "(min-width: 992px)",
    "fullscreen": "(min-width: 1200px)",
    "ultrawide": "(min-width: 1400px)",
    "motion": "(prefers-reduced-motion)",
    "hover": "(any-hover: hover)",
    "dark": "(prefers-color-scheme: dark)",
    "light": "(prefers-color-scheme: light)"
  },
  "colors": {
    "1": "#FF0801",
    "2": "#FF5501",
    "3": "#E29500",
    "4": "#A7B820",
    "5": "#6CD115",
    "6": "#20AE43",
    "7": "#1FA685",
    "8": "#49B1BF",
    "9": "#1B57CE",
    "10": "#7E15E3",
    "11": "#FF01B1",
    "12": "#FF0162",
    "assorted1": "#FF0801",
    "assorted2": "#FF5501",
    "assorted3": "#E29500",
    "assorted4": "#A7B820",
    "assorted5": "#6CD115",
    "assorted6": "#20AE43",
    "assorted7": "#1FA685",
    "assorted8": "#49B1BF",
    "assorted9": "#1B57CE",
    "assorted10": "#7E15E3",
    "assorted11": "#FF01B1",
    "assorted12": "#FF0162",
    "statusSuccessBackgroundDefault": "#D4F7DA",
    "statusSuccessBackgroundAlt": "#157926",
    "statusErrorBackgroundDefault": "#FFD0CC",
    "statusErrorBackgroundAlt": "#B80F00",
    "statusAlertBackgroundDefault": "#FFF6CC",
    "statusAlertBackgroundAlt": "#856F00",
    "statusInfoBackgroundDefault": "#CCEEFF",
    "statusInfoBackgroundAlt": "#006DA3",
    "statusSuccessNonInteractivePredominant": "#000000",
    "statusSuccessNonInteractiveAuxiliar": "#0B4114",
    "statusSuccessNonInteractiveEmphasis": "#126D22",
    "statusSuccessNonInteractiveOutline": "rgba(0, 0, 0, 0.16)",
    "statusSuccessNonInteractiveAltPredominant": "#FFFFFF",
    "statusSuccessNonInteractiveAltAuxiliar": "#E9FBEC",
    "statusSuccessNonInteractiveAltEmphasis": "#C7F5CE",
    "statusSuccessNonInteractiveAltOutline": "rgba(255, 255, 255, 0.24)",
    "statusErrorNonInteractivePredominant": "#000000",
    "statusErrorNonInteractiveAuxiliar": "#661100",
    "statusErrorNonInteractiveEmphasis": "#BD1F00",
    "statusErrorNonInteractiveOutline": "rgba(0, 0, 0, 0.16)",
    "statusErrorNonInteractiveAltPredominant": "#FFFFFF",
    "statusErrorNonInteractiveAltAuxiliar": "#FFE8E5",
    "statusErrorNonInteractiveAltEmphasis": "#FFC7C2",
    "statusErrorNonInteractiveAltOutline": "rgba(255, 255, 255, 0.24)",
    "statusAlertNonInteractivePredominant": "#000000",
    "statusAlertNonInteractiveAuxiliar": "#574800",
    "statusAlertNonInteractiveEmphasis": "#806A00",
    "statusAlertNonInteractiveOutline": "rgba(0, 0, 0, 0.16)",
    "statusAlertNonInteractiveAltPredominant": "#FFFFFF",
    "statusAlertNonInteractiveAltAuxiliar": "#FFFBE5",
    "statusAlertNonInteractiveAltEmphasis": "#FFF6C7",
    "statusAlertNonInteractiveAltOutline": "rgba(255, 255, 255, 0.24)",
    "statusInfoNonInteractivePredominant": "#000000",
    "statusInfoNonInteractiveAuxiliar": "#004466",
    "statusInfoNonInteractiveEmphasis": "#006DA3",
    "statusInfoNonInteractiveOutline": "rgba(0, 0, 0, 0.16)",
    "statusInfoNonInteractiveAltPredominant": "#FFFFFF",
    "statusInfoNonInteractiveAltAuxiliar": "#E5F6FF",
    "statusInfoNonInteractiveAltEmphasis": "#C7ECFF",
    "statusInfoNonInteractiveAltOutline": "rgba(255, 255, 255, 0.24)",
    "statusSuccessActionableDefault": "#17872A",
    "statusSuccessActionableHover": "#126D22",
    "statusSuccessActionableActive": "#0B4114",
    "statusSuccessActionableContent": "#FFFFFF",
    "statusSuccessActionableAlt": "#3FDE5A",
    "statusSuccessActionableAltHover": "#85EA96",
    "statusSuccessActionableAltActive": "#B1F2BB",
    "statusSuccessActionableAltContent": "#000000",
    "statusErrorActionableDefault": "#E52600",
    "statusErrorActionableHover": "#C22000",
    "statusErrorActionableActive": "#8F1800",
    "statusErrorActionableContent": "#FFFFFF",
    "statusErrorActionableAlt": "#FF938A",
    "statusErrorActionableAltHover": "#FFC2BD",
    "statusErrorActionableAltActive": "#FFE8E5",
    "statusErrorActionableAltContent": "#000000",
    "statusAlertActionableDefault": "#8A7300",
    "statusAlertActionableHover": "#756200",
    "statusAlertActionableActive": "#4D4000",
    "statusAlertActionableContent": "#FFFFFF",
    "statusAlertActionableAlt": "#FFD400",
    "statusAlertActionableAltHover": "#FFE357",
    "statusAlertActionableAltActive": "#FFF2B2",
    "statusAlertActionableAltContent": "#000000",
    "statusInfoActionableDefault": "#006DA3",
    "statusInfoActionableHover": "#004E75",
    "statusInfoActionableActive": "#00334D",
    "statusInfoActionableContent": "#FFFFFF",
    "statusInfoActionableAlt": "#66CCFF",
    "statusInfoActionableAltHover": "#99DDFF",
    "statusInfoActionableAltActive": "#CCEEFF",
    "statusInfoActionableAltContent": "#000000",
    "statusSuccessNonPrimaryButtonDefault": "rgba(26, 153, 47, 0)",
    "statusSuccessNonPrimaryButtonHover": "rgba(26, 153, 47, 0.16)",
    "statusSuccessNonPrimaryButtonActive": "rgba(26, 153, 47, 0.32)",
    "statusSuccessNonPrimaryButtonContent": "#157A26",
    "statusSuccessNonPrimaryButtonStroke": "#1A992F",
    "statusSuccessNonPrimaryButtonAlt": "rgba(63, 222, 90, 0)",
    "statusSuccessNonPrimaryButtonAltHover": "rgba(63, 222, 90, 0.32)",
    "statusSuccessNonPrimaryButtonAltActive": "rgba(63, 222, 90, 0.48)",
    "statusSuccessNonPrimaryButtonAltContent": "#C2F5CA",
    "statusSuccessNonPrimaryButtonAltStroke": "#3FDE5A",
    "statusErrorNonPrimaryButtonDefault": "rgba(229, 38, 0, 0)",
    "statusErrorNonPrimaryButtonHover": "rgba(229, 38, 0, 0.16)",
    "statusErrorNonPrimaryButtonActive": "rgba(229, 38, 0, 0.32)",
    "statusErrorNonPrimaryButtonContent": "#BD1F00",
    "statusErrorNonPrimaryButtonStroke": "#E52600",
    "statusErrorNonPrimaryButtonAlt": "rgba(255, 147, 138, 0)",
    "statusErrorNonPrimaryButtonAltHover": "rgba(255, 147, 138, 0.32)",
    "statusErrorNonPrimaryButtonAltActive": "rgba(255, 147, 138, 0.48)",
    "statusErrorNonPrimaryButtonAltContent": "#FFC7C2",
    "statusErrorNonPrimaryButtonAltStroke": "#FF938A",
    "statusAlertNonPrimaryButtonDefault": "rgba(163, 136, 0, 0)",
    "statusAlertNonPrimaryButtonHover": "rgba(163, 136, 0, 0.16)",
    "statusAlertNonPrimaryButtonActive": "rgba(163, 136, 0, 0.32)",
    "statusAlertNonPrimaryButtonContent": "#806A00",
    "statusAlertNonPrimaryButtonStroke": "#9E8400",
    "statusAlertNonPrimaryButtonAlt": "rgba(255, 212, 0, 0)",
    "statusAlertNonPrimaryButtonAltHover": "rgba(255, 212, 0, 0.32)",
    "statusAlertNonPrimaryButtonAltActive": "rgba(255, 212, 0, 0.48)",
    "statusAlertNonPrimaryButtonAltContent": "#FFF6C7",
    "statusAlertNonPrimaryButtonAltStroke": "#FFD400",
    "statusInfoNonPrimaryButtonDefault": "rgba(0, 136, 204, 0)",
    "statusInfoNonPrimaryButtonHover": "rgba(0, 136, 204, 0.16)",
    "statusInfoNonPrimaryButtonActive": "rgba(0, 136, 204, 0.32)",
    "statusInfoNonPrimaryButtonContent": "#006DA3",
    "statusInfoNonPrimaryButtonStroke": "#0088CC",
    "statusInfoNonPrimaryButtonAlt": "rgba(102, 204, 255, 0)",
    "statusInfoNonPrimaryButtonAltHover": "rgba(102, 204, 255, 0.32)",
    "statusInfoNonPrimaryButtonAltActive": "rgba(102, 204, 255, 0.48)",
    "statusInfoNonPrimaryButtonAltContent": "#C7ECFF",
    "statusInfoNonPrimaryButtonAltStroke": "#66CCFF",
    "nonPrimaryButtonDefault": "rgba(0, 57, 72, 0)",
    "nonPrimaryButtonHover": "rgba(0, 57, 72, 0.16)",
    "nonPrimaryButtonActive": "rgba(0, 57, 72, 0.32)",
    "nonPrimaryButtonContent": "#003948",
    "nonPrimaryButtonStroke": "#003948",
    "nonPrimaryButtonAlt": "rgba(255, 255, 255, 0)",
    "nonPrimaryButtonAltHover": "rgba(255, 255, 255, 0.24)",
    "nonPrimaryButtonAltActive": "rgba(255, 255, 255, 0.4)",
    "nonPrimaryButtonAltContent": "#FFFFFF",
    "nonPrimaryButtonAltStroke": "#FFFFFF",
    "actionSuccessStatic": "#0DAB01",
    "actionSuccessHighlight": "#005800",
    "actionSuccessDisabled": "rgba(255, 255, 255, 0.24)",
    "actionAlertStatic": "#FF9700",
    "actionAlertHighlight": "#c66800",
    "actionAlertDisabled": "rgba(255, 255, 255, 0.24)",
    "error-standard": "#DE1616",
    "error-alt": "#FF6666",
    "success-standard": "#0DAB01",
    "success-alt": "#70DD67",
    "alert-standard": "#FF9700",
    "alert-alt": "#FBC679",
    "whatsapp": "#128C7E",
    "facebook": "#0078FF",
    "supportWhatsapp": "#128C7E",
    "supportFacebook": "#0078FF",
    "gradient-1": "#1174AB",
    "gradient-2": "#96308F",
    "gradient-3": "#8EC740",
    "gradient-4": "#3E9559",
    "overlay": "rgba(0, 0, 0, 0.3)",
    "disabledDark": "rgba(0, 0, 0, 0.16)",
    "disabled": "rgba(255, 255, 255, 0.24)",
    "background": "#FFFFFF",
    "shadowLight": "hsl(206 22% 7% / 35%)",
    "shadowDark": "hsl(206 22% 7% / 20%)",
    "backgroundPrimary": "#FFFFFF",
    "backgroundSecondary": "#FAF6F5",
    "backgroundTertiary": "#ECF4F8",
    "backgroundAltPrimary": "#003948",
    "backgroundAltSecondary": "#222222",
    "backgroundAltTertiary": "#052235",
    "nonInteractivePredominant": "#222222",
    "nonInteractiveAuxiliar": "#666666",
    "nonInteractiveEmphasis": "#003948",
    "nonInteractiveAltPredominant": "#FFFFFF",
    "nonInteractiveAltAuxiliar": "#CCCCCC",
    "nonInteractiveAltEmphasis": "#B3FFCC",
    "nonInteractiveOutline": "rgba(0, 0, 0, 0.24)",
    "nonInteractiveAltOutline": "rgba(255, 255, 255, 0.48)",
    "linkDefault": "#003948",
    "linkHover": "#087D2F",
    "linkVisited": "#001014",
    "linkAlt": "#72F69E",
    "linkAltHover": "#A4F9C0",
    "linkAltVisited": "#E0F9FF",
    "conversionButtonDefault": "#83493E",
    "conversionButtonHover": "#61372E",
    "conversionButtonActive": "#3E231E",
    "conversionButtonContent": "#FFFFFF",
    "conversionButtonAlt": "#F1E7E3",
    "conversionButtonAltHover": "#E0CBC2",
    "conversionButtonAltActive": "#CFADA0",
    "conversionButtonAltContent": "#003948",
    "actionableDefault": "#003948",
    "actionableHover": "#087D2F",
    "actionableActive": "#001014",
    "actionableContent": "#FFFFFF",
    "actionableAlt": "#FFFFFF",
    "actionableAltHover": "rgba(255, 255, 255, 0.8)",
    "actionableAltActive": "rgba(255, 255, 255, .64)",
    "actionableAltContent": "#003948",
    "disabledBackground": "rgba(0,0,0, .24)",
    "disabledContent": "rgba(0,0,0, .48)",
    "disabledAltBackground": "rgba(255, 255, 255, .24)",
    "disabledAltContent": "rgba(255, 255, 255, .48)",
    "keyboardFocusDefault": "#003948",
    "keyboardFocusAlt": "#F0E8E4"
  },
  "fonts": {
    "primary": "Sora, Helvetica, Open Sans, Arial",
    "secondary": "Roboto, Helvetica, Open Sans, Arial"
  },
  "sizes": {
    "0": "0rem",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem",
    "11": "2.75rem",
    "12": "3rem",
    "13": "3.25rem",
    "14": "3.5rem",
    "15": "3.75rem",
    "16": "4rem",
    "17": "4.25rem",
    "18": "4.5rem",
    "19": "4.75rem",
    "20": "5rem",
    "21": "5.25rem",
    "22": "5.5rem",
    "23": "5.75rem"
  },
  "space": {
    "0": "0rem",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem",
    "11": "2.75rem",
    "12": "3rem",
    "13": "3.25rem",
    "14": "3.5rem",
    "15": "3.75rem",
    "16": "4rem",
    "17": "4.25rem",
    "18": "4.5rem",
    "19": "4.75rem",
    "20": "5rem",
    "21": "5.25rem",
    "22": "5.5rem",
    "23": "5.75rem"
  },
  "fontSizes": {
    "restricted": "0.688rem",
    "exceptionsRestricted": "0.688rem",
    "auxiliar": "0.75rem",
    "exceptionsAuxiliar": "0.75rem",
    "bodySmall": "0.875rem",
    "bodyLarge": "1rem",
    "subtitleMobile": "1.25rem",
    "subtitleDesk": "1.5rem",
    "titleMobile": "1.75rem",
    "titleDesk": "2rem",
    "headingMobile": "2.25rem",
    "headingDesk": "2.5rem",
    "displayMobile": "3.25rem",
    "displayDesk": "4rem"
  },
  "shadows": {
    "downSoft": "0px 4px 20px 0px rgba(0, 0, 0, 0.12)",
    "downClose": "0px 4px 8px -4px rgba(0, 0, 0, 0.32)",
    "downMid": "0px 4px 24px -8px rgba(0, 0, 0, 0.4)",
    "downFar": "0px 8px 24px -8px rgba(0, 0, 0, 0.4)",
    "upSoft": "0px -4px 20px 0px rgba(0, 0, 0, 0.12)",
    "upClose": "0px -4px 8px -4px rgba(0, 0, 0, 0.32)",
    "upMid": "0px -4px 24px -8px rgba(0, 0, 0, 0.4)",
    "upFar": "0px -8px 24px -8px rgba(0, 0, 0, 0.40)",
    "rightSoft": "4px 0px 20px 0px rgba(0, 0, 0, 0.12)",
    "rightClose": "4px 0px 8px -4px rgba(0, 0, 0, 0.32)",
    "rightFar": "8px 0px 24px -8px rgba(0, 0, 0, 0.40)",
    "rightMid": "4px 0px 24px -8px rgba(0, 0, 0, 0.4)",
    "leftSoft": "-4px 0px 20px 0px rgba(0, 0, 0, 0.12)",
    "leftClose": "-4px 0px 8px -4px rgba(0, 0, 0, 0.32)",
    "leftMid": "-4px 0px 24px -8px rgba(0, 0, 0, 0.4)",
    "leftFar": "-8px 0px 24px -8px rgba(0, 0, 0, 0.40)",
    "centerSoft": "0px 0px 20px 0px rgba(0, 0, 0, 0.12)",
    "centerClose": "0px 0px 8px 0px rgba(0, 0, 0, 0.22)",
    "centerMid": "0px 0px 16px 0px rgba(0, 0, 0, 0.24)",
    "centerFar": "0px 0px 20px 0px rgba(0, 0, 0, 0.32)",
    "outline": "0 0 0 2px rgba(0, 120, 255, 0.8)"
  },
  "letterSpacings": {
    "tighter": "-0.05em",
    "tight": "-0.025em",
    "normal": "0",
    "wide": "0.025em",
    "wider": "0.05em",
    "widest": "0.1em"
  },
  "lineHeights": {
    "normal": 1.2,
    "none": 1,
    "shorter": 1.25,
    "short": 1.375,
    "base": 1.5,
    "tall": 1.625,
    "taller": 2,
    "displayDesk": "4.875rem",
    "displayMobile": "4rem",
    "headingDesk": "3.125rem",
    "headingMobile": "2.875rem",
    "titleDesk": "2.5rem",
    "titleMobile": "2.25rem",
    "subtitleDesk": "2rem",
    "subtitleMobile": "1.75rem",
    "bodyLargeStandard": "1.5rem",
    "bodyLargeShort": "1.25rem",
    "bodySmallStandard": "1.25rem",
    "bodySmallShort": "1rem",
    "exceptionsAuxiliar": "1rem",
    "exceptionsRestricted": "1rem"
  },
  "textDecorations": {
    "underline": "underline",
    "strikeThrough": "line-through"
  },
  "fontWeights": {
    "regular": 400,
    "medium": 500,
    "heavy": 600,
    "light": 300,
    "strong": "bolder",
    "bold": 700
  },
  "borderWidths": {
    "none": 0,
    "hairline": "1px",
    "thin": "2px",
    "medium": "4px",
    "thick": "8px"
  },
  "radii": {
    "sharp": "0px",
    "small": "4px",
    "medium": "8px",
    "large": "16px",
    "pill": "100%"
  },
  "zIndices": {
    "hide": -1,
    "auto": "auto",
    "base": 0,
    "docked": 10,
    "dropdown": 1000,
    "sticky": 1100,
    "banner": 1200,
    "overlay": 1300,
    "modal": 1400,
    "popover": 1500,
    "skipLink": 1600,
    "toast": 1700,
    "tooltip": 1800
  }
};